import { Injectable } from '@angular/core';
import { ManagementPageSessionStorageService } from '../shared/management-page-session-storage.service';
import type { ActivitiesPageSessionState } from '../../presentations/models/activities-management.model';
import type { ActivityDrawerSessionState } from '../../presentations/models/activity-drawer-session.model';

export type ActivitiesModalSessionState = {
  url: string;
  modalScrollPosition: number;
  activityDrawer: ActivityDrawerSessionState;
  deleteDialogVisible: boolean;
  deleteDialogClosing: boolean;
  deleteConfirmed: boolean;
};

@Injectable({ providedIn: 'root' })
export class ActivitiesManagementPageSessionService {
  private readonly modalStorageKey = 'smatchy:bo:activities-management:modal-state';
  private readonly pageStorageKey = 'smatchy:bo:activities-management:page-state';

  constructor(private storage: ManagementPageSessionStorageService) {}

  readPageState(): ActivitiesPageSessionState | null {
    return this.storage.read<ActivitiesPageSessionState>(this.pageStorageKey);
  }

  savePageState(state: ActivitiesPageSessionState) {
    this.storage.save(this.pageStorageKey, state);
  }

  clearPageState() {
    this.storage.clear(this.pageStorageKey);
  }

  readModalState(): ActivitiesModalSessionState | null {
    return this.storage.read<ActivitiesModalSessionState>(this.modalStorageKey);
  }

  saveModalState(state: ActivitiesModalSessionState) {
    this.storage.save(this.modalStorageKey, state);
  }

  clearModalState() {
    this.storage.clear(this.modalStorageKey);
  }
}
